import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  projectsDescriptionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
  },
  tilesWrapper: {
    '& .projects-order': {
      marginBottom: '82px',
    },
  },
}));
